import { defineStore } from 'pinia';
import { reactive, ref, watch } from 'vue';

import type { ModalName } from '@/constants/modals';

export const useModalStore = defineStore('modal', () => {
	// biome-ignore lint/suspicious/noExplicitAny: Init Biome
	const props = ref<{ [key: string]: any }>({});
	// biome-ignore lint/suspicious/noExplicitAny: Init Biome
	const injectedProps = ref<{ [key: string]: any }>({});
	const open = ref<ModalName[]>([]);

	const close = (modal: ModalName) => {
		open.value = open.value.filter((m) => m !== modal);
	};

	const closeAll = () => {
		open.value = [];
	};

	// biome-ignore lint/suspicious/noExplicitAny: Init Biome
	const setProps = (modal: ModalName, payload: any) => {
		props.value[modal] = payload;
	};

	// biome-ignore lint/suspicious/noExplicitAny: Init Biome
	const injectProps = (modal: ModalName, payload: any) => {
		injectedProps.value[modal] = payload;
	};

	const injectManyProps = (
		// biome-ignore lint/suspicious/noExplicitAny: Init Biome
		propsByModal: { modal: ModalName; payload: any }[]
	) => {
		propsByModal.forEach(({ modal, payload }) => {
			injectedProps.value[modal] = payload;
		});
	};

	const resetInjectedProps = () => {
		injectedProps.value = {};
	};

	// biome-ignore lint/suspicious/noExplicitAny: Init Biome
	const openModal = (modal: ModalName, payload: any = {}) => {
		if (!open.value.includes(modal)) open.value.push(modal);
		props.value[modal] = payload;
	};

	const waitForAllClosed = (): Promise<void> => {
		if (open.value.length === 0) return Promise.resolve();
		return new Promise((resolve) => {
			const unwatch = watch(
				() => open.value.length,
				(count) => {
					if (count > 0) return;
					unwatch();
					resolve();
				}
			);
		});
	};

	return {
		state: reactive({
			open,
			props,
			injectedProps,
		}),
		actions: reactive({
			open: openModal,
			close,
			closeAll,
			setProps,
			injectProps,
			resetInjectedProps,
			injectManyProps,
			waitForAllClosed,
		}),
	};
});
